if (document.body.classList.contains("contact")) {
    if (document.querySelectorAll("span.error").length > 0) {
        let scroll = document.querySelector("form").offsetTop - window.innerWidth * 0.064236111111
        window.scrollTo(0, scroll)
    }
}